<template>
  <div>
    <headernav></headernav>
    <swiper class="con" ref="mySwiper" :options="swiperOption">
      <swiper-slide style="height: 100%;">
        <img src="../assets/img/bg@2x.jpg" alt="" />
        <div id="con1">
          <h2>能监宝-综合能源管理平台</h2>
          <p>12年智慧用电、能源能耗管理、电力运维专业积累</p>
          <div class="diamonds"></div>
          <a @click="paslogin">点击体验云平台</a>
        </div>
      </swiper-slide>
      <swiper-slide style="height: 100%;">
        <img src="../assets/img/bg@2x (4).jpg" alt="" />
        <div id="con2">
          <div class="con-right">
            <img class="left" src="../assets/img/2-提升业绩@2x.png" alt="" />
            <div>
              <h2>提升运维安全</h2>
              <p>服务更可靠、管理更省心</p>
            </div>
          </div>
          <div class="con-left">
            <img
              class="right"
              src="../assets/img/2-提升业绩 copy@2x.png"
              alt=""
            />
            <div class="right">
              <h2>成本大幅降低</h2>
              <p>降低综合运维成本60%</p>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide style="height: 100%;">
        <img src="../assets/img/bg@2x (5).jpg" alt="" />
        <div id="con3">
          <ul>
            <li>
              <img src="../assets/img/云端下载@2x.png" alt="" />
              <p>云端存储</p>
              <h2>01</h2>
            </li>
            <li>
              <img src="../assets/img/免费@2x.png" alt="" />
              <p>系统免费</p>
              <h2>02</h2>
            </li>
            <li>
              <img src="../assets/img/服务@2x.png" alt="" />
              <p>本地服务</p>
              <h2>03</h2>
            </li>
            <li>
              <img src="../assets/img/投入品管理@2x.png" alt="" />
              <p>投入低廉</p>
              <h2>04</h2>
            </li>
          </ul>
          <router-link to="/index/bdgj">了解更多</router-link>
        </div>
      </swiper-slide>
      <swiper-slide style="height: 100%;">
        <footerend></footerend>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import headernav from "../components/common/headernav";
import footerend from "../components/common/homefot";
export default {
  name: "",
  components: {
    headernav,
    footerend,
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        direction: "vertical",
        slidesPerView: 1,
        spaceBetween: 0,
        mousewheelControl: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        paginationBulletRender: function(swiper, index, className) {
          return (
            '<div class="' +
            className +
            '">' +
            '<p class="numa">' +
            "0" +
            (index + 1) +
            "</p>" +
            "</div>"
          );
        }
      }
    };
  },
  created() {},
  methods: {
    // 登录页面
    paslogin() {
      window.location.href = `http://trms.freshpower.com.cn//#/login?userName=tykh&password=fdcb5d1f1897523d210e49c38e6b6613`;
    }
  }
};
</script>

<style scoped>
@import "../assets/css/indexcopy.css";
.swiper-slide {
  height: 800px;
}

.pagination >>> .swiper-wrapper {
  width: 100% !important;
  height: 100% !important;
}
.pagination >>> .swiper-slide,
.pagination >>> .swiper-slide-active {
  width: 100% !important;
  height: 100% !important;
}

/* .swiper-slide img,
.swiper-slide-active img{
  width: 100%;
  position: relative;
} */
</style>



// WEBPACK FOOTER //
// src/pages/home.vue